<script>
export default {
  data() {
    return {};
  },
  methods: {
    submitForm() {
      this.$router.push("/");
    },
  },
};
</script>
<template>
  <div class="authentication-page">
    <div class="d-flex justify-content-between vh-100 overflow-auto flex-column">
      <!-- Header -->
      <div class="authentication-header">
        <div class="container">
          <div class="col-md-12">
            <div class="text-center">
              <img src="@/assets/img/logo.svg" alt="logo" />
            </div>
          </div>
        </div>
      </div>
      <!-- /Header -->

      <!-- Main Wrapper -->
      <div class="main-wrapper">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-md-5 mx-auto">
              <form @submit.prevent="submitForm">
                <div class="d-flex flex-column justify-content-center">
                  <div class="card p-sm-4 my-5">
                    <div class="card-div">
                      <div class="text-center mb-3">
                        <h3 class="mb-2">Provider Signup</h3>
                        <p>Enter your credentials to access your account</p>
                      </div>
                      <div class="mb-3">
                        <label class="form-label">First Name</label>
                        <input type="text" class="form-control" />
                      </div>
                      <div class="mb-3">
                        <label class="form-label">Email</label>
                        <input type="email" class="form-control" />
                      </div>
                      <div class="mb-3">
                        <label class="form-label">Phone Number</label>
                        <input class="form-control" id="phone" name="phone" type="text" />
                      </div>
                      <div class="mb-3">
                        <div
                          class="d-flex align-items-center justify-content-between flex-wrap"
                        >
                          <label class="form-label">Password</label>
                          <p class="text-gray-6 fw-medium mb-1">
                            Must be 8 Characters at Least
                          </p>
                        </div>
                        <input type="password" class="form-control" />
                      </div>
                      <div class="mb-3">
                        <div
                          class="d-flex align-items-center justify-content-between flex-wrap row-gap-2"
                        >
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              value=""
                              id="remember_me"
                            />
                            <label class="form-check-label" for="remember_me">
                              I agree to
                              <a
                                href="javascript:void(0);"
                                class="text-primary text-decoration-underline"
                                >Terms of use</a
                              >
                              &
                              <a
                                href="javascript:void(0);"
                                class="text-primary text-decoration-underline"
                                >Privacy policy</a
                              >
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="mb-3">
                        <button type="submit" class="btn btn-lg btn-linear-primary w-100">
                          Sign Up
                        </button>
                      </div>
                      <div class="login-or mb-3">
                        <span class="span-or">Or sign up with </span>
                      </div>
                      <div class="d-flex align-items-center mb-3">
                        <a
                          href="javascript:void(0);"
                          class="btn btn-light flex-fill d-flex align-items-center justify-content-center me-3"
                          ><img
                            src="@/assets/img/icons/google-icon.svg"
                            class="me-2"
                            alt="Img"
                          />Google</a
                        >
                        <a
                          href="javascript:void(0);"
                          class="btn btn-light flex-fill d-flex align-items-center justify-content-center"
                          ><img
                            src="@/assets/img/icons/fb-icon.svg"
                            class="me-2"
                            alt="Img"
                          />Facebook</a
                        >
                      </div>
                      <div class="d-flex justify-content-center">
                        <p>
                          Already have a account?
                          <router-link to="/" class="text-primary"
                            >Sign In</router-link
                          >
                        </p>
                      </div>
                    </div>
                    <div>
                      <img
                        src="@/assets/img/bg/authentication-bg.png"
                        class="bg-left-top"
                        alt="Img"
                      />
                      <img
                        src="@/assets/img/bg/authentication-bg.png"
                        class="bg-right-bottom"
                        alt="Img"
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- /Main Wrapper -->

      <!-- Footer -->
      <div class="footer-copyright bg-transparent">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <p>Copyright &copy; 2024. All Rights Reserved Truelysell</p>
            </div>
          </div>
        </div>
      </div>
      <!-- /Footer -->
    </div>

    <div class="back-to-top">
      <a
        class="back-to-top-icon align-items-center justify-content-center d-flex"
        href="#top"
        ><i class="fa-solid fa-arrow-up"></i
      ></a>
    </div>

    <!-- Cursor -->
    <div class="xb-cursor tx-js-cursor">
      <div class="xb-cursor-wrapper">
        <div class="xb-cursor--follower xb-js-follower"></div>
      </div>
    </div>
    <!-- /Cursor -->
  </div>
</template>
